// extracted by mini-css-extract-plugin
module.exports = {"root":"Settings_root__3aZIQ","search":"Settings_search__218vz","filter":"Settings_filter__1X2bh"};